import React, { useMemo } from "react";
import Layout from "app/components/layouts";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";

import PartOne from "app/components/Individual/personalDetails/PartOne";
import PartTwo from "app/components/Individual/personalDetails/PartTwo";
import PartThree from "app/components/Individual/personalDetails/PartThree";
import PartFour from "app/components/Individual/personalDetails/PartFour";
import PartFive from "app/components/Individual/personalDetails/PartFive";
import LoanTypeStepper from "app/components/common/LoanTypeStepper";
import { StepsComponent } from "app/utils/types";

const PersonalDetails: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.personalDetails.currentStep
  );

  const steps = useMemo<StepsComponent[]>(
    () => [
      <PartOne key="personal-details-1" />,
      <PartTwo key="personal-details-2" />,
      <PartThree key="personal-details-3" />,
      <PartFour key="personal-details-4" />,
      <PartFive key="personal-details-5" />,
    ],
    []
  );

  const renderStep = useMemo(() => {
    const stepToRender = currentStep === 5 ? 4 : currentStep;

    if (currentStep >= 0 && stepToRender < steps.length) {
      return steps[stepToRender];
    }
    return <PartOne />;
  }, [currentStep, steps]);

  return (
    <>
      <Layout>
        <LoanTypeStepper />
        {renderStep}
      </Layout>
    </>
  );
};

export default PersonalDetails;
